module.exports = __webpack_public_path__ + "static/og-bfa9d506dab19809ba041b58811a10f6.png";